<template>
    <button
        type="button"
        class="button contact-popup__trigger"
        :class="{ 'contact-popup__trigger--pulse': pulse }"
        @click="$emit('open')"
    >
        {{ label }}
    </button>
</template>

<script>
const MOBILE_MEDIA_QUERY = "(max-width: 480px)";

export default {
    name: "ContactPopupTrigger",
    props: {
        pulse: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["open"],
    data() {
        return {
            isMobile: false,
        };
    },
    computed: {
        label() {
            return this.isMobile ? "Vraag stellen" : "Stel direct je vraag";
        },
    },
    mounted() {
        this.mediaQuery = window.matchMedia(MOBILE_MEDIA_QUERY);
        this.isMobile = this.mediaQuery.matches;
        this.mediaQuery.addEventListener("change", this.onMediaQueryChange);
    },
    beforeUnmount() {
        this.mediaQuery?.removeEventListener("change", this.onMediaQueryChange);
    },
    methods: {
        onMediaQueryChange(event) {
            this.isMobile = event.matches;
        },
    },
};
</script>
